import React, {useEffect, useState} from "react";
import "./TrainingPage.sass";
import StudentGrid from "../../../../_components/student/StudentGrid";
import {useDispatch, useSelector} from "react-redux";
import ButtonComponent from "../../../../_components/common/buttons/ButtonComponent";
import {ReactComponent as TrainingIcon} from "../../../../images/release/training.svg";
import TrainingTable from "../../../../_components/student/trainingTable/TrainingTable";
import {useNavigate} from "react-router";
import {IDLE, LOADING} from "../../../../common/statuses";
import {getTrainingHistory} from "../../../../_actions/training/trainingService";
import Spinner from "../../anonymous/Spinner";
import {clearTrainingState} from "../../../../_actions/training/trainingReducer";
import EmptyCourseBlock from "../../../../_containers/infoblock/EmptyCourseBlock";
import {ROLE_STUDENT} from "../../../../common/roles";
import TeacherGrid from "../../../../_components/teacher/TeacherGrid";
import {ADDRESS} from "../../../../_api/client";
import {COMMON_HOMEWORK_EDITOR_PAGE} from "../../../../common/links";

export default function MentalTrainingPage() {

    const [svgList, setSvgList] = useState({});

    const {courses, role} = useSelector(state => state.auth.current)
    const {status} = useSelector(state => state.training.tasks);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        if (status === IDLE) {
            dispatch(getTrainingHistory());
        }
    }, [status, dispatch]);
    useEffect(() => {
        if (courses) {
            courses.forEach(c => {
                if (c.avatar) {
                    fetch(`${ADDRESS}/avatar/svg/${c.avatar}`)
                        .then(res => res.text())
                        .then((payload) => {
                            const res = {...svgList};
                            res[c.avatar] = payload;

                            setSvgList(res);
                        })
                }
            })
        }
    }, [courses])
    useEffect(() => {
        document.title = 'КьюАй - Тренировка'
        return () => {
            dispatch(clearTrainingState())
        }
    }, [])

    if (status === IDLE || status === LOADING) {
        return <Spinner/>
    }

    const renderMentalHW = () => {
        const style = {
            backgroundColor: 'rgb(85, 204, 120)',
            display: 'flex',
            flexDirection: 'column',
        }
        const course = courses.find(course => course.name === "Ментальная арифметика");
        if (course) {
            return <>
                <div className="TrainingPage-tab-wrapper">
                    {course.avatar && <div className="TrainingPage-tab-icon"
                                           dangerouslySetInnerHTML={{__html: svgList[course.avatar]}}></div>}
                    <div className="TrainingPage-tab-label">Ментальная арифметика</div>
                    <div><ButtonComponent style={style}
                                          onClick={() => navigate(COMMON_HOMEWORK_EDITOR_PAGE)}>
                        <div><TrainingIcon style={{width: '1.3em', height: '1.3em'}}/></div>
                        <div style={{fontSize: '0.6em'}}>Начать</div>
                    </ButtonComponent></div>
                </div>
                <TrainingTable/>
            </>
        } else {
            return <EmptyCourseBlock text="Для тебя нет тренировки"/>
        }
    }

    return (
        <div className="TrainingPage-wrapper">
            {
                role === ROLE_STUDENT ? <StudentGrid/> : <TeacherGrid/>
            }

            <div className="TrainingPage-table-wrapper">
                {renderMentalHW()}
            </div>
        </div>
    )
}